"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var _emotion = require("emotion");

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isTextTruthy = function isTextTruthy(val) {
  return val !== undefined && val !== null && val.toString() !== '';
};

var TextField = _react["default"].forwardRef(function (_ref, ref) {
  var _cx;

  var autoFocus = _ref.autoFocus,
      bsStyle = _ref.bsStyle,
      className = _ref.className,
      disabled = _ref.disabled,
      helpText = _ref.helpText,
      id = _ref.id,
      inputStyle = _ref.inputStyle,
      label = _ref.label,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onClick = _ref.onClick,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      placeholder = _ref.placeholder,
      required = _ref.required,
      rightAddon = _ref.rightAddon,
      style = _ref.style,
      type = _ref.type,
      value = _ref.value,
      pattern = _ref.pattern,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["autoFocus", "bsStyle", "className", "disabled", "helpText", "id", "inputStyle", "label", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "placeholder", "required", "rightAddon", "style", "type", "value", "pattern"]);

  var _useState = (0, _react.useState)(isTextTruthy(value)),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      _float = _useState2[0],
      setFloat = _useState2[1];

  var uniqueId = (0, _utils.useMemoizedId)({
    label: "".concat(name, "-").concat(placeholder, "-").concat(label)
  });
  (0, _react.useEffect)(function () {
    setFloat(isTextTruthy(value));
  }, [setFloat, value]);

  var handleBlur = function handleBlur(e) {
    setFloat(isTextTruthy(value));
    onBlur && onBlur(e);
  };

  var handleFocus = function handleFocus(e) {
    setFloat(true);
    onFocus && onFocus(e);
  };

  var handleChange = function handleChange(e) {
    var isValid = !pattern || !!e.target.value.match(new RegExp("^".concat(pattern, "$")));
    onChange && onChange(_objectSpread({}, e, {
      isValid: isValid
    }));
  };

  var inputId = id || uniqueId;
  var isTextArea = type === 'textarea';
  var wrapperClassNames = (0, _emotion.cx)('form-group', className, (_cx = {
    'form-group-active': label && _float
  }, (0, _defineProperty2["default"])(_cx, "has-".concat(bsStyle), bsStyle), (0, _defineProperty2["default"])(_cx, "required", required), (0, _defineProperty2["default"])(_cx, "disabled", disabled), _cx));

  var inputProps = _objectSpread({}, rest, {
    autoFocus: autoFocus,
    className: 'form-control',
    disabled: disabled,
    id: inputId,
    name: name,
    onBlur: handleBlur,
    onChange: handleChange,
    onClick: onClick,
    onFocus: handleFocus,
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    ref: ref,
    required: required,
    style: inputStyle,
    value: value,
    pattern: pattern
  });

  if (!isTextArea) {
    inputProps.type = type;
  }

  var inputElement = isTextArea ? _react["default"].createElement("textarea", inputProps) : _react["default"].createElement("input", inputProps);
  var labelElement = label ? _react["default"].createElement("label", {
    className: (0, _emotion.cx)('control-label', {
      'textarea-label': isTextArea
    }),
    htmlFor: inputId,
    title: label
  }, label) : null;
  return _react["default"].createElement("div", {
    className: wrapperClassNames,
    style: style
  }, _react["default"].createElement("div", {
    className: "input-group",
    style: {
      width: '100%',
      zIndex: 0
    }
  }, inputElement, labelElement, rightAddon && _react["default"].createElement("span", {
    className: "input-group-btn"
  }, rightAddon)), helpText ? _react["default"].createElement("small", {
    className: "help-block"
  }, helpText) : null);
});

TextField.displayName = 'TextField';
TextField.defaultProps = {
  autoFocus: false,
  className: '',
  disabled: false,
  required: false,
  type: 'text',
  value: ''
};
TextField.propTypes = {
  name: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(['text', 'number', 'password', 'url', 'search', 'email', 'tel', 'textarea']),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  label: _propTypes["default"].node,
  placeholder: _propTypes["default"].string,
  helpText: _propTypes["default"].node,
  id: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  autoFocus: _propTypes["default"].bool,
  bsStyle: _propTypes["default"].oneOf(['success', 'warning', 'error', '']),
  className: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  style: _reactStyleProptype["default"],
  inputStyle: _reactStyleProptype["default"],
  rightAddon: _propTypes["default"].element,
  pattern: _propTypes["default"].string
};
var _default = TextField;
exports["default"] = _default;